// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y1YBQ","field":"styles_field__t64J6","fieldCol":"styles_fieldCol__28Sr3","diffCol":"styles_diffCol__2c7DC","diff":"styles_diff__2aPk5"};